import axios from 'axios';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { closePaymentModal, useFlutterwave } from 'flutterwave-react-v3';

export default function TopupCard({ wallet }) {
  const [amount, setAmount] = useState(0);
  const user = JSON.parse(localStorage.getItem('userData'));
  const token = localStorage.getItem('token');

  const config = {
    // public_key: 'FLWPUBK-6c0ee8e4de551d099268e6c21fb8d97d-X',
    public_key: 'FLWPUBK-5ec0308c8e98d16ca318ae5664a3b1fd-X',
    tx_ref: uuidv4(),
    amount: amount,
    currency: wallet && wallet.currency_code,
    payment_options: 'card,mobilemoney,ussd',
    customer: {
      email: user.email,
      name: user.name,
    },
    customizations: {
      title: 'Fund SmartRewards account wallet',
      description: 'Payment for SmartRewards wallet',
      logo: 'https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
    },
  };

  const handleFlutterPayment = useFlutterwave(config);
  return (
    <div className={'mt-11 w-full'}>
      <div
        className={
          'w-full flex flex-col lg:flex-row lg:justify-between lg:items-center'
        }
      >
        <input
          className={
            'flex-grow p-2 lg:px-3 lg:py-2 mb-3 lg:mb-0 mr-0 lg:mr-3 bg-gray-50 border-2'
          }
          placeholder={`Enter amount in ${wallet && wallet.currency_code}`}
          min="1"
          onChange={(e) => setAmount(e.target.value)}
          type={'number'}
        />
        <button
          disabled={!amount}
          onClick={() => {
            axios
              .post(
                'https://secret-ridge-31139.herokuapp.com/api/wallet/create_transaction',
                {
                  user_id: wallet && wallet.user_id,
                  wallet_no: wallet && wallet.wallet_no,
                  amount: amount,
                  tx_ref: config.tx_ref,
                  currency: wallet && wallet.currency_code,
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then((res) => res);
            handleFlutterPayment({
              callback: (response) => {
                closePaymentModal(); // this will close the modal programmatically
              },
              onClose: () => {},
            });
          }}
          className={
            'w-full lg:w-auto shadow border-yellow-500 text-yellow-500 border-2 rounded-sm p-2 lg:px-3 lg:py-2 text-sm lg:text-base'
          }
        >
          Fund wallet
        </button>
      </div>
    </div>
  );
}
